import { FC } from 'react';
import Box from '@mui/material/Box';
import { IconButton, Tooltip } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { ReactComponent as BlocksIcon } from 'assets/images/SidebarIcons/blocks.svg';
import { ReactComponent as VariablesIcon } from 'assets/images/SidebarIcons/variables.svg';
import { ReactComponent as SettingsIcon } from 'assets/images/SidebarIcons/settings.svg';
import styles from './SidebarButton.module.css';
import { useAppSelector } from 'app/hooks';
import { DocumentType, selectDocumentType, selectSelectedItem } from 'features/document/documentSlice';
import { SidebarSectionsEnum } from 'features/document/constants';
import { selectIsSalesforceAuth } from 'features/salesforce/salesforceSlice';

interface SidebarButtonProps {
  handleToggleSidebar: () => void;
  setSidebarSection: (section: SidebarSectionsEnum) => void;
  openBlocksBar: boolean;
  sidebarSection?: string;
}

const SidebarButton: FC<SidebarButtonProps> = ({
  handleToggleSidebar,
  sidebarSection = SidebarSectionsEnum.Blocks,
  setSidebarSection,
  openBlocksBar,
}: SidebarButtonProps) => {
  const documentType = useAppSelector(selectDocumentType);
  const isSalesforceAuth = useAppSelector(selectIsSalesforceAuth);
  const selectedItem = useAppSelector(selectSelectedItem);

  const isVariablesActive =
    isSalesforceAuth &&
    (documentType === DocumentType.CONTRACT ||
      documentType === DocumentType.QUOTE ||
      documentType === DocumentType.PRECLOSING);

  const getButtonClassnames = (sidebarSectionInput: SidebarSectionsEnum) => {
    return `${styles.sidebarButton} ${sidebarSection === sidebarSectionInput ? styles.sidebarButtonSelected : ''}`;
  };
  return (
    <div className={styles.drawerLeftRight}>
      <Tooltip title={openBlocksBar ? 'Hide Side Bar' : 'Show Side Bar'} arrow>
        <IconButton
          onClick={() => {
            handleToggleSidebar();
          }}
        >
          {openBlocksBar ? <KeyboardArrowRightIcon fontSize='small' /> : <KeyboardArrowLeftIcon fontSize='small' />}
        </IconButton>
      </Tooltip>
      {openBlocksBar && (
        <>
          <Tooltip title='Content Blocks' arrow placement={"left"}>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              width='40px'
              height='40px'
              marginBottom='5px'
              className={getButtonClassnames(SidebarSectionsEnum.Blocks)}
              onClick={() => {
                setSidebarSection(SidebarSectionsEnum.Blocks);
              }}
            >
              <BlocksIcon />
            </Box>
          </Tooltip>
          {isVariablesActive && (
            <Tooltip title='Variables' arrow placement={"left"}>
              <Box
                display='flex'
                alignItems='center'
                justifyContent='center'
                width='40px'
                height='40px'
                marginBottom='5px'
                className={getButtonClassnames(SidebarSectionsEnum.Variables)}
                onClick={() => {
                  setSidebarSection(SidebarSectionsEnum.Variables);
                }}
              >
                <VariablesIcon />
              </Box>
            </Tooltip>
          )}
          {selectedItem && (
            <Tooltip title='Text Editor Block' arrow placement={"left"}>
              <Box
                display='flex'
                alignItems='center'
                justifyContent='center'
                width='40px'
                height='40px'
                marginBottom='5px'
                className={getButtonClassnames(SidebarSectionsEnum.TextEditor)}
                onClick={() => {
                  setSidebarSection(SidebarSectionsEnum.TextEditor);
                }}
              >
                <SettingsIcon />
              </Box>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default SidebarButton;
